import React, { Component } from 'react'
import { Link } from 'react-router'
import { Button } from 'hljd'
import { observer, Provider } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import { CARD_ATLAS_MANAGE_PATH } from '@constant'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepsBar from './StepsBar'
import styles from './style.module.less'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id },
      location: { query = {} }
    } = this.props
    this.store = new Store({ id, step: query.step })
  }

  render() {
    const { step, backList } = this.store
    const header = [
      <Link to={CARD_ATLAS_MANAGE_PATH}>转介绍图集管理</Link>,
      '编辑图集'
    ]

    return (
      <Provider parentStore={this.store}>
        <HeaderView
          header={header}
          title={'编辑图集'}
          extra={
            step === 2 ? (
              <Button onClick={() => backList()} type="primary">
                完成
              </Button>
            ) : (
              ''
            )
          }
        >
          <div className={`${styles.detail} antd-hlj-small`}>
            <StepsBar />
            {+step === 1 && <StepOne />}
            {+step === 2 && <StepTwo />}
          </div>
        </HeaderView>
      </Provider>
    )
  }
}
